import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Formats event start/end date using event timezone
 * @param {Object} row - event object
 * @returns {string}
 */
export const formatEventDate = (row) => {
  const tz = row?.event_timezone || "UTC";

  // Handle start date
  if (!row?.start_date) return "TBD";

  const startDate = dayjs.utc(row.start_date).tz(tz);

  // If there's an end date and it's different from start date, show range
  if (row?.end_date && row.end_date !== row.start_date) {
    const endDate = dayjs.utc(row.end_date).tz(tz);

    // Same month & year
    if (
      startDate.year() === endDate.year() &&
      startDate.month() === endDate.month()
    ) {
      return `${startDate.format("MM/DD/YYYY")} - ${endDate.format(
        "MM/DD/YYYY"
      )}`;
    }
    // Same year
    else if (startDate.year() === endDate.year()) {
      return `${startDate.format("MM/DD/YYYY")} - ${endDate.format(
        "MM/DD/YYYY"
      )}`;
    }
    // Different years
    else {
      return `${startDate.format("MM/DD/YYYY")} - ${endDate.format(
        "MM/DD/YYYY"
      )}`;
    }
  }

  // Single day event
  return startDate.format("MM/DD/YYYY");
};
